/* Reuse the current menu's product badges on cards and product galleries. */
(() => {
  if (window.__evolvedProductHighlights) return;
  window.__evolvedProductHighlights = true;

  if (!customElements.get('evolved-gallery-sale-badge')) {
    customElements.define('evolved-gallery-sale-badge', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const form = document.forms[this.getAttribute('form')];
        form?.addEventListener('variant:change', (event) => {
          const variant = event.detail?.variant;
          this.hidden = !(variant && Number(variant.compare_at_price) > Number(variant.price));
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  // Keep the popup's existing appearance and React nodes while correcting its heading level.
  const repairPopupHeadings = (root) => {
    if (!(root instanceof Element || root instanceof Document)) return;
    const headings = Array.from(root.querySelectorAll('form.klaviyo-form h3'));
    if (root instanceof Element && root.matches('form.klaviyo-form h3')) headings.push(root);
    const parentHeading = root instanceof Element ? root.closest('form.klaviyo-form h3') : null;
    if (parentHeading) headings.push(parentHeading);
    headings.forEach((heading) => {
      if (heading.textContent.trim() !== 'Sign up for exclusive offers and updates') return;
      heading.setAttribute('role', 'heading');
      heading.setAttribute('aria-level', '2');
    });
  };

  const targetSelector = 'product-card[handle], product-gallery[data-product-handle], .ev-guide-card[data-guide-product]';
  let badgeMap = new Map();
  let scheduled = false;
  const pending = new Set();

  const readMenu = () => {
    const next = new Map();
    document.querySelectorAll('[data-evolved-collection-badge]').forEach((link) => {
      const type = link.dataset.evolvedCollectionBadge;
      if (type !== 'new' && type !== 'best_seller') return;
      const heading = link.querySelector('[data-evolved-menu-heading]');
      if (!heading) return;
      let badge = heading.querySelector('[data-evolved-menu-badge]');
      if (!badge) {
        badge = document.createElement('span');
        badge.dataset.evolvedMenuBadge = '';
        heading.append(badge);
      }
      badge.className = `evolved-menu-badge evolved-menu-badge--${type}`;
      badge.textContent = type === 'new' ? 'New' : 'Best Seller';
      badge.style.backgroundColor = type === 'new' ? '#00a341' : '#0066dd';
      badge.style.color = '#ffffff';
      badge.style.borderRadius = '12px';
    });
    document.querySelectorAll('[data-evolved-menu-badge]').forEach((badge) => {
      const link = badge.closest('a[href]');
      if (!link || !badge.textContent.trim()) return;
      const match = new URL(link.href, location.origin).pathname.match(/\/products\/([^/]+)\/?$/);
      if (!match || next.has(match[1])) return;
      const style = getComputedStyle(badge);
      next.set(match[1], {
        text: badge.textContent.trim(),
        color: style.color,
        background: style.backgroundColor,
        border: style.borderColor,
        borderWidth: style.borderTopWidth
      });
    });
    badgeMap = next;
  };

  const decorate = (target) => {
    const handle = target.getAttribute('handle') || target.dataset.productHandle || target.dataset.guideProduct;
    const detail = badgeMap.get(handle);
    const compactSurface = target.querySelector('.ev-card-meta');
    const surface = compactSurface || (target.matches('product-card')
      ? target.querySelector('.product-card__badge-row') || target.querySelector('.product-card__figure')
      : target.querySelector('.product-gallery__badge-stack') || target.querySelector('.product-gallery__media-list-wrapper'));
    if (!surface) return;
    const currentBadges = [...surface.querySelectorAll('.ev-product-highlight-badge')];
    let badge = currentBadges.find(node => node.dataset.evolvedProductBadge === 'automatic') || currentBadges[0];
    currentBadges.forEach(node => { if (node !== badge) node.remove(); });
    const highlightText = badge?.dataset.evolvedProductBadge === 'automatic' ? badge.textContent : detail?.text;
    if (compactSurface && highlightText) {
      const normalized = highlightText.trim().replace(/\s+/g, ' ').toLowerCase();
      compactSurface.querySelectorAll('.ev-card-meta__label:not(.ev-card-meta__highlight)').forEach(label => {
        if (label.textContent.trim().replace(/\s+/g, ' ').toLowerCase() === normalized) label.remove();
      });
    }
    if (badge?.dataset.evolvedProductBadge === 'automatic') return;
    if (!detail) { badge?.remove(); return; }
    if (!badge) {
      badge = document.createElement('span');
      badge.className = compactSurface ? 'ev-product-highlight-badge ev-card-meta__label ev-card-meta__highlight' : 'ev-product-highlight-badge';
      surface.append(badge);
    }
    if (badge.textContent !== detail.text) badge.textContent = detail.text;
    if (compactSurface) { badge.style.setProperty("--ev-badge-color", detail.background); return; }
    badge.style.color = detail.color;
    badge.style.backgroundColor = detail.background;
    badge.style.borderColor = detail.border;
    badge.style.borderWidth = detail.borderWidth;
  };

  const collect = (root) => {
    if (!(root instanceof Element || root instanceof Document)) return;
    if (root instanceof Element && root.matches(targetSelector)) pending.add(root);
    root.querySelectorAll(targetSelector).forEach((target) => pending.add(target));
  };

  const flush = () => {
    scheduled = false;
    pending.forEach((target) => { if (target.isConnected) decorate(target); });
    pending.clear();
  };
  const schedule = () => {
    if (scheduled || !pending.size) return;
    scheduled = true;
    requestAnimationFrame(flush);
  };

  const init = () => {
    readMenu();
    collect(document);
    flush();
    repairPopupHeadings(document);
    new MutationObserver((records) => {
      records.forEach((record) => record.addedNodes.forEach((node) => {
        collect(node);
        repairPopupHeadings(node instanceof Element ? node : node.parentElement);
      }));
      schedule();
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', () => {
      readMenu();
      collect(document);
      schedule();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

